import axios from 'axios'
import { Message, Loading } from 'element-ui'

//创建axios的一个实例

let valid = true

const instance = axios.create({
    timeout: 20000,
    // showLoading : true
    headers: {
        'Content-Type': 'application/json',
    },
})

const cancels = {}
window._axiosPromiseArr = [] //用于批量取消请求
window._axiosCancel = {} //用于取消请求
let showLoading
// instance.headers.showLoading = true

instance.interceptors.request.use(function (config) {
    window._axiosCancel[config.url] ? window._axiosCancel[config.url]() : null

    config.cancelToken = new axios.CancelToken(cancel => {
        let isCancel = config.url === '/heating/api/dev/count' || config.url === '/heating/api/police/hisList'

        if (isCancel) return;
        window._axiosCancel[config.url] = cancel
        window._axiosPromiseArr.push({ cancel })
    })

    if (config.showLoading) {
        showLoading = Loading.service({
            lock: config.showLoading,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.3)'
        })
    }

    if (config.imgUrl) {
        config.responseType = 'blob'
    }

    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'

    const token = sessionStorage.getItem('token')

    if (config.url == '/auth/login') {
        config.headers.Authorization = ''
    } else {
        config.headers.Authorization = token ? "Bearer " + token : ''
    }


    return config;
}, function (error) {
    return Promise.reject(error);
});



instance.interceptors.response.use(function (response) {
    const { msg, code } = response.data

    if (showLoading) {
        showLoading.close();
    }
    let message = ''
    switch (code) {
        case 401:
            Message.error({
                duration: 2000,
                message: "登录过期"
            })
            window.location.href = '/#/login'
            break;
        case 500:
            message = '程序内部错误'
            if (msg) { message = msg }
            Message.error({
                duration: 2000,
                message: message
            })
            break;
        case 100001:
            // message = '登录参数错误'
            Message.error({
                duration: 2000,
                message: "登录参数错误"
            })
            // window.location.href = '/#/login'
            return;
        case 100002:
            if(!valid) return;
            Message.error({
                duration: 2000,
                message: "Token无效"
            })
            window.location.href = '/#/login'
            valid = false;
            setTimeout(() => {
                valid = true;
            }, 1000)
            break;
        case 100003:
            // message = '没有权限'
            Message.error({
                duration: 2000,
                message: "没有权限"
            })
            break
        case 100004:
            // message = '验证码无效'
            Message.error({
                duration: 2000,
                message: "验证码无效"
            })
            window.location.href = '/#/login'
            return {
                redress: true
            }
        case 100005:
            Message.error({
                duration: 2000,
                message: "许可证已过期，请上传最新许可证"
            })
            break;
        case 100006:
            Message.error({
                duration: 2000,
                message: "网关数量超过许可证资源总配额"
            })
            break;
        case 100007:
            Message.error({
                duration: 2000,
                message: "应用数量超过许可证资源总配额"
            })
            break;
        case 100008:
            Message.error({
                duration: 2000,
                message: "数据点数量超过许可证资源总配额"
            })
            break;
        case 100010:
            // message = '资源已存在'
            Message.error({
                duration: 2000,
                message: "资源已存在"
            })
            break
        case 100011:
            // message = '资源不存在'
            Message.error({
                duration: 2000,
                message: "资源不存在"
            })
            break;
        case 100012:
            // message = '参数错误'
            Message.error({
                duration: 2000,
                message: "参数错误"
            })
            break;
        case 200010:
            Message.error({
                duration: 2000,
                message: "资源已存在"
            })
            break;
        case 200012:
            Message.error({
                duration: 2000,
                message: "参数错误"
            })
            break;
    }
    if (message) {
        return {
            error: message
        }
    }
    return response.data;
}, function (error) {
    // 这里是返回状态码不为200时候的错误处理
    // const { status } = error.response
  console.error('http.js',error)
    if (showLoading) {
        showLoading.close();
    }
    return Promise.reject(error);
});



export default function ({ method = "get", url, data = null, cancelName = null, showLoading = true, imgUrl = false }) {
    method = method.toLowerCase();

    if (method === 'post') {
        return instance.post(url, data, { showLoading, imgUrl })
    } else if (method === 'get') {
        return instance.get(url, { params: data, showLoading })
    } else if (method === 'delete') {
        return instance.delete(url, { data: data, showLoading })
    } else if (method === 'put') {
        return instance.put(url, data, { showLoading })
    } else {
        console.error('未知的method' + method)
        return false
    }
}





